import(/* webpackMode: "eager" */ "/codebuild/output/src829137711/src/Divine-infinite-ui-next/src/app/(admin)/admin/perennial/page.tsx");
